var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconArrowOpenDownLine extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconArrowOpenDown",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "m.153 526.146 92.168-92.299 867.767 867.636 867.636-867.636 92.429 92.299-960.065 959.935z",
      fillRule: "evenodd"
    })));
  }
}
IconArrowOpenDownLine.glyphName = 'arrow-open-down';
IconArrowOpenDownLine.variant = 'Line';
IconArrowOpenDownLine.displayName = 'IconArrowOpenDownLine';
IconArrowOpenDownLine.propTypes = {
  ...SVGIcon.propTypes
};
IconArrowOpenDownLine.allowedProps = [...SVGIcon.allowedProps];
export default IconArrowOpenDownLine;
export { IconArrowOpenDownLine };